const isDriverLeaderboard = (
  slide: DashboardType | WeatherBoardType | DriverLeaderboardSlide | undefined,
): slide is DriverLeaderboardSlide => {
  return (
    slide !== undefined &&
    (slide as DriverLeaderboardSlide).kind === 'driverLeaderboard'
  );
};

export default isDriverLeaderboard;
